<template>
    <div class="container text-center py-4 py-lg-10">
        <div class="row d-lg-flex align-items-lg-center justify-content-center">
            <div class="col-lg-6 mb-5 mb-lg-0 col-xl-5 _offset-xl-1">
                <h1 class="font-weight-bold m-0">
                    <div class="d-inline-block">{{ $t('pages.checkins_list.tips_form_title_1') }}</div>
                </h1>
                <h3 class="mb-4 h2 mt-2 text-secondary">{{ $t('pages.checkins_list.tips_form_subtitle') }}</h3>
                <div class="row mt-5">
                    <div class="col-lg-8 offset-lg-2">
                        <CheckinMaker/>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 offset-lg-1 d-none">
                <div class="py-0 py-lg-3 px-4 h4 m-0 rounded d-lg-flex align-items-start justify-content-between">
                    <div class="small pr-lg-3 font-weight-normal text-center text-lg-left">
                        {{ $t('pages.checkins_list.tips_title') }}
                    </div>
                    <div class="d-inline-block h1 mt-2 mt-lg-0">&#x1F4A1;</div>
                </div>
                <div class="tips-wrapper">
                    <div class="tips-wrapper__media-wrapper">
                        <img src="@/assets/tips-picacode.svg">
                            <div class="tips-wrapper__media-wrapper__number-tips">{{ $t('pages.checkins.tips_number') }}</div>
                            <div class="tips-wrapper__media-wrapper__letter-tips">{{ $t('pages.checkins.tips_letter') }}</div>
                    </div>
                    <!--                            <div class="h6 mt-4 text-secondary">{{ $t('pages.checkins_list.tips_caption_image_1') }} <span class="code">{{ $t('pages.checkins_list.tips_caption_image_2') }}</span><br>{{ $t('pages.checkins_list.tips_caption_image_3') }}</div>-->
                    <div class="tips-section mt-4">
                        {{ $t('pages.checkins_list.tips_contacts_part1') }} <a href="mailto:support@getpica.com">{{
                        $t('pages.checkins_list.tips_contacts_part2') }}</a>.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import CheckinMaker from '@/components/CheckinMaker'

    export default {
        components: {
            CheckinMaker,
        },
    }
</script>
